import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_END_POINT } from "config";


const rawBaseQuery = fetchBaseQuery({
    baseUrl: API_END_POINT,
    prepareHeaders: (headers, { getState }) => {
        // const token = getState()?.auth?.token;
        const token = sessionStorage.getItem("token");

        // if (token) {
        headers.set("Authorization", `Bearer ${localStorage.getItem('token')}`);
        // }
        return headers;
    },
    paramsSerializer: (params) => {
        const queryString = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((v) => queryString.append(key, v));
            } else if (value !== undefined && value !== null) {
                queryString.append(key, value);
            }
        });
        return queryString.toString();
    },
});

const baseQueryWith401Handling = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {

        sessionStorage.removeItem("token");
        localStorage.removeItem("token");

        window.location.href = "/login";

        return {
            error: {
                status: 401,
                data: "Unauthorized",
            },
        };
    }

    return result;
};

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: baseQueryWith401Handling,
    endpoints: () => ({}),
    tagTypes: ["DMS"],
});



// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { API_END_POINT } from "config";

// // Define the API slice
// export const apiSlice = createApi({
//     reducerPath: "api",
//     baseQuery: fetchBaseQuery({
//         baseUrl: API_END_POINT,
//         prepareHeaders: (headers, { getState }) => {

//             // const token = getState()?.auth?.token;
//             const token = sessionStorage.getItem("token");

//             // if (token) {
//             headers.set("Authorization", `Bearer ${localStorage.getItem('token')}`);
//             // }
//             return headers;
//         },
//         paramsSerializer: (params) => {
//             const queryString = new URLSearchParams();
//             Object.entries(params).forEach(([key, value]) => {
//                 if (Array.isArray(value)) {
//                     value.forEach(v => queryString.append(key, v));
//                 } else {
//                     queryString.append(key, value);
//                 }
//             });
//             return queryString.toString();
//         },
//     }),
//     endpoints: () => ({}),
// });


